import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	padding: '0 24px',
	backgroundColor: theme.palette.neutral[0],
	height: '100%',
}));

export const DrawerContent = styled('div')(() => ({
	padding: 24,
	minHeight: '100%',
	display: 'flex',
	flexDirection: 'column',
	boxSizing: 'border-box',
	position: 'relative',
}));

export const Wrapper = styled('div')(({ theme }) => ({
	height: '100%',
	overflow: 'auto',
	backgroundColor: theme.palette.primary.light,
}));

export const WelcomeRoot = styled('div')(({ theme }) => ({
	boxSizing: 'border-box',
	padding: '48px 24px',
	height: '100%',
	overflow: 'auto',
}));

export const WelcomeTitle = styled('div')(({ theme }) => ({
	...theme.typography.desktopTitle,
	color: theme.palette.primary.main,
	marginBottom: 32,
}));

export const SubmitLevel = styled('div')(({ theme }) => ({
	position: 'absolute',
	bottom: 0,
	width: 'calc(100% - 48px)',
	margin: '16px 24px',
	borderRadius: '8px 8px 0 0',
}));

export const BrowserTitle = styled('div')(({ theme }) => ({
	...theme.typography.body1,
	fontWeight: 600,
	color: theme.palette.primary.dark,
	marginTop: 32,
	marginBottom: 26,
}));

export const LoginBox = styled(Box)(({ theme }) => ({
	display: 'grid',
	gridAutoFlow: 'column',
	gridTemplateColumns: 'max-content',
	alignItems: 'center',
	color: theme.palette.primary.dark,
	marginBottom: 18,

	'& > span': {
		...theme.typography.body1,
		fontWeight: 600,
		marginRight: 16,
	},
}));
